import '../assets/NcMentionBubble-ptHUq68a.css';
import { generateUrl } from "@nextcloud/router";
import { checkIfDarkTheme } from "../functions/isDarkTheme/index.mjs";
function getAvatarUrl(user, options) {
  const size = (options?.size || 64) <= 64 ? 64 : 512;
  const guestUrl = options?.isGuest ? "/guest" : "";
  const themeUrl = options?.isDarkTheme ?? checkIfDarkTheme(document.body) ? "/dark" : "";
  return generateUrl(`/avatar${guestUrl}/{user}/{size}${themeUrl}`, {
    user,
    size
  });
}
export {
  getAvatarUrl as g
};
//# sourceMappingURL=NcMentionBubble.vue_vue_type_style_index_0_scoped_45238efd_lang-D6LzDiYf.mjs.map
